module.exports = __webpack_public_path__ + "static/img/voucher02.a3aff36.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/question/voucher02.jpg
// module id = W6a/
// module chunks = 4